import { createUseStyles } from 'react-jss'

import { zIndex3 } from '../../../../../styles/const/common'

const slide = data => {
  if (!data) return 0
  const { selectedStoriesItemIndex } = data

  if (!selectedStoriesItemIndex) {
    return 0
  } else {
    return -195 * selectedStoriesItemIndex
  }
}

export default createUseStyles({
  AdStoriesItem: {
    minWidth: 195,
    minHeight: 345,
    flex: 1,
    position: 'relative',
    transition: 'all .5s',

    '&:first-child': {
      marginLeft: data => slide(data)
    }
  },
  adStoriesCardSide: {
    top: 0,
    // width is decreased from 50% to 35% to allow to put play button between 2 sides of story item
    width: '35%',
    height: '100%',
    position: 'absolute',
    cursor: 'pointer',
    zIndex: zIndex3
  },
  adStoriesCardLeftSide: {
    left: 0
  },
  adStoriesCardRightSide: {
    right: 0
  }
})
